
import React, { useRef, useEffect, useState, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import './style.css';

import Layout from '../../components/Layout/AdminLayout/AdminLayout';

import {
    ResponseCreateMember, MembersRegistryError, RequestMembersRegistryFirstTab, MembersTabInfo,
    RequestMembersRegistrySecondTab, RequestMembersRegistryThirdTab,
    ResultCreateMember, MembersTabInfoDto, ResultDeparment, ResultCivilStatus
} from '../../interface/IMembersRegistry';
import { Response, ApiResponse } from '../../interface/IResponse';

import membersRegistryService from './membersRegistryService';

import SuccessModal from '../../components/Modal/SuccessModal';

import DatePicker from "react-datepicker";
import Select from 'react-select';

import helpers from '../../helpers/index';


import iconVisible from '../../assets/visible.png';
import iconHide from '../../assets/hide.png';
import { request } from 'http';
import { SkipPreviousTwoTone } from '@mui/icons-material';

function CreateMember() {
    var dispatch = useDispatch();
    const navigate = useNavigate();

    const [isReadOnly, setIsReadOnly] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState('');
    const [requestMembersRegistryFirstTab, setRequestMembersRegistryFirstTab] = useState<RequestMembersRegistryFirstTab>({});
    const [requestMembersRegistrySecondTab, setRequestMembersRegistrySecondTab] = useState<RequestMembersRegistrySecondTab>({});
    const [requestMembersRegistryThirdTab, setRequestMembersRegistryThirdTab] = useState<RequestMembersRegistryThirdTab>({});


    const [memberRegistryError, setMemberRegistryError] = useState<MembersRegistryError>({});
    const [memberTabInfo, setMemberTabInfo] = useState<MembersTabInfo>({});
    // const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedGender, setSelectedGender] = useState('');
    const [selectedMembershipType, setSelectedMembershipType] = useState('');
    const [currentTabIndex, setCurrentTabIndex] = useState(0);
    const [numberInput, setNumberInput] = useState('');
    const [isNextButtonVisible, setIsNextButtonVisible] = useState(true);
    const [isPreviousButtonVisible, setIsPreviousButtonVisible] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [autoGeneratedUsername, setAutoGeneratedUsername] = useState('');
    const [autoGeneratedPassword, setAutoGeneratedPassword] = useState('');
    const [age, setAge] = useState(0);
    const [dateOfBirth, setDateOfBirth] = useState<Date | null>(new Date());

    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);

    const [departmentSelectData, setDepartmentSelectData] = useState<SelectData[]>([]);

    const [civilStatusList, setCivilStatusList] = useState<ResultCivilStatus[]>([]);

    interface SelectData {
        label: string;
        value: number;
    }


    const errMessage = "This parameter is required for creating an account";

    function getPermission() {

        var permission = helpers.getPermission();
        setIsReadOnly(permission == "ReadOnly");
    }

    async function loadCivilStatusList() {

        try {

            var axiosResponse = await membersRegistryService.getCivilStatusList();

            var response: ApiResponse<ResultCivilStatus[]> = axiosResponse.data;

            setCivilStatusList(response.result);

        }
        catch (err) {
            console.log('SetCivilStatusList:: ', err);
        }
    }


    function HasRequirementErrorTab1(): boolean {

        var membersRegistryError: MembersRegistryError = {};
        setMemberRegistryError(memberRegistryError);

        if (!requestMembersRegistryFirstTab.departmentId) {
            membersRegistryError.department = errMessage;
        }

        if (!requestMembersRegistryFirstTab.firstname) {
            membersRegistryError.firstname = errMessage;
        }

        if (!requestMembersRegistryFirstTab.lastname) {
            membersRegistryError.lastname = errMessage;
        }

        if (!requestMembersRegistryFirstTab.username) {
            membersRegistryError.username = errMessage;
        }

        if (!requestMembersRegistryFirstTab.password) {
            membersRegistryError.password = errMessage;
        }

        if (!confirmPassword) {
            membersRegistryError.confirmPassword = errMessage;
        }

        if (requestMembersRegistryFirstTab.password != confirmPassword) {
            membersRegistryError.confirmPassword = "Passwrod and confirm password must be equal.";

        }

        if (!requestMembersRegistryFirstTab.email) {
            membersRegistryError.email = errMessage;
        }

        if (!requestMembersRegistryFirstTab.contactNo) {
            membersRegistryError.contactNo = errMessage;
        }

        if (Object.values(membersRegistryError).some(error => error)) {

            setMemberRegistryError(membersRegistryError);

            return true;
        }
        else {
            return false;
        }

    }

    function HasRequirementErrorTab2(): boolean {

        var membersRegistryError: MembersRegistryError = {};

        if (!requestMembersRegistrySecondTab.address) {
            membersRegistryError.address = errMessage;
        }

        // if(!dateOfBirthRef.current?.value){
        //     membersRegistryError.dateOfBirth = errMessage;
        // }

        if (!requestMembersRegistrySecondTab.dateOfBirth) {
            membersRegistryError.dateOfBirth = errMessage;
        }

        if (!requestMembersRegistrySecondTab.age) {
            membersRegistryError.age = errMessage;
        }

        if (!requestMembersRegistrySecondTab.gender) {
            membersRegistryError.gender = errMessage;
        }

        if (!requestMembersRegistrySecondTab.civilStatus) {
            membersRegistryError.civilStatus = errMessage;
        }

        if (!requestMembersRegistrySecondTab.educationalAttainment) {
            membersRegistryError.educationalAttainment = errMessage;
        }

        if (!requestMembersRegistrySecondTab.religion) {
            membersRegistryError.religion = errMessage;
        }

        if(!requestMembersRegistrySecondTab.bodResNo){
            membersRegistryError.bodResNo = errMessage;
        }


        if (Object.values(membersRegistryError).some(error => error)) {

            setMemberRegistryError(membersRegistryError);

            return true;
        }
        else {
            return false;
        }

    }

    function HasRequirementErrorTab3(): boolean {


        var membersRegistryError: MembersRegistryError = {};

        if (!requestMembersRegistryThirdTab.occupation) {
            membersRegistryError.occupation = errMessage;
        }

        if (!requestMembersRegistryThirdTab.annualIncome) {
            membersRegistryError.annualIncome = errMessage;
        }

        if (!requestMembersRegistryThirdTab.numberOfDependents) {
            membersRegistryError.numberOfDependents = errMessage;
        }

        if (!requestMembersRegistryThirdTab.dateAccepted) {
            membersRegistryError.dateAccepted = errMessage;
        }

        // if (!requestMembersRegistryThirdTab.bodResNoTermination) {
        //     membersRegistryError.bodResNoTermination = errMessage;
        // }

        if (!requestMembersRegistryThirdTab.membershipType) {
            membersRegistryError.membershipType = errMessage;
        }


        if (Object.values(membersRegistryError).some(error => error)) {

            setMemberRegistryError(membersRegistryError);

            return true;
        }
        else {
            return false;
        }

    }

    async function updateMemberFirstTabClick(payload: RequestMembersRegistryFirstTab) {

        try {
            if (!HasRequirementErrorTab1()) {

                var id: number = memberTabInfo.memberId ?? 0;

                await membersRegistryService.updateMembersFirstTab(id, payload);

                return true;
            }
            return false;

        }
        catch (err) {
            return false;
        }
    }

    async function updateMemberSecondTabClick(payload: RequestMembersRegistrySecondTab): Promise<boolean> {
        try {
            if (!HasRequirementErrorTab2()) {

                var id: number = memberTabInfo.memberId ?? 0;

                await membersRegistryService.updateMembersSecondTab(id, payload);

                return true;
            }
            return false;

        }
        catch (err) {
            console.log('updateMemberSecondTabClick error:: ', err);
            return false;
        }
    }

    async function createMemberFirstTabClick(payload: RequestMembersRegistryFirstTab): Promise<boolean> {

        try {

            if (!HasRequirementErrorTab1()) {

                setMemberRegistryError({});
                const response = await membersRegistryService.createMembers(payload);
                var resultData: ResponseCreateMember = response.data;
                var result: ResultCreateMember = resultData.result;

                if (resultData.isSuccess) {

                    var memberTabInfo: MembersTabInfoDto = result.membersTabInfoDto;

                    const tabInfo: MembersTabInfo = {
                        memberId: memberTabInfo.memberId,
                        membershipId: memberTabInfo.membershipId,
                        username: memberTabInfo.username
                    }

                    setMemberTabInfo(tabInfo);

                    return true;
                }
                else {
                    if (result.isEmailDuplicate) {
                        setMemberRegistryError((prevState) => ({
                            ...prevState,
                            email: "Email is already exists"
                        }));
                    }

                    if (result.isUsernameDuplicate) {
                        setMemberRegistryError((prevState) => ({
                            ...prevState,
                            username: "Username is already exists"
                        }));
                    }

                    return false;

                }

            }
            else {
                return false;
            }

        }
        catch (err) {
            console.log('createMemberFirstTabClick error:: ', err);
            throw err;
        }

    }


    async function createMemberThirdTabClick() {

        try {
            document.querySelector('.loader-container')?.classList.add('loader');
            if (!HasRequirementErrorTab3()) {


                var id: number = memberTabInfo.memberId ?? 0;



                var payload: RequestMembersRegistryThirdTab = {

                    occupation: requestMembersRegistryThirdTab.occupation,
                    annualIncome: requestMembersRegistryThirdTab.annualIncome,
                    numberOfDependents: requestMembersRegistryThirdTab.numberOfDependents,
                    dateAccepted: requestMembersRegistryThirdTab.dateAccepted ? new Date(requestMembersRegistryThirdTab.dateAccepted) : null,
                    dateOfSeparation: requestMembersRegistryThirdTab.dateOfSeparation ? new Date(requestMembersRegistryThirdTab.dateOfSeparation) : null,
                    bodResNoTermination: requestMembersRegistryThirdTab.bodResNoTermination,
                    membershipType: requestMembersRegistryThirdTab.membershipType,
                    amountSubscribe: requestMembersRegistryThirdTab.amountSubscribe,
                    initialPaidAmount: requestMembersRegistryThirdTab.initialPaidAmount
                }


                // await membersRegistryService.updateMembersThirdTab(id,payload);
                await membersRegistryService.createUpdateMembersThirdTab(id, payload);
                setIsSuccessModalOpen(true);
            }

        }
        catch (err) {
            console.log('createMemberThirdTabClick error:: ', err);
            throw err;
        }
        finally {
            document.querySelector('.loader-container')?.classList.remove('loader');
        }

    }


    var tabs = document.querySelectorAll('.tab');


    function openTab(tabName: string) {
        tabs.forEach(function (tab) {
            tab.classList.remove('active');
        });

        var tab: any = document.getElementById(tabName);
        tab.classList.add('active');

        // Update currentTabIndex
        setCurrentTabIndex(Array.from(tabs).indexOf(tab));
    }

    async function openNextTab() {
        // Calculate index of next tab

        var isSuccess: boolean = false;

        try {

            document.querySelector('.loader-container')?.classList.add('loader');

            if (currentTabIndex == 0) {


                var payload: RequestMembersRegistryFirstTab = {
                    departmentId: requestMembersRegistryFirstTab.departmentId,
                    firstname: requestMembersRegistryFirstTab.firstname,
                    middlename: requestMembersRegistryFirstTab.middlename,
                    lastname: requestMembersRegistryFirstTab.lastname,
                    username: requestMembersRegistryFirstTab.username,
                    password: requestMembersRegistryFirstTab.password,
                    email: requestMembersRegistryFirstTab.email,
                    contactNo: requestMembersRegistryFirstTab.contactNo,
                    taxIdNo: requestMembersRegistryFirstTab.taxIdNo
                };


                if (memberTabInfo.memberId) {
                    isSuccess = await updateMemberFirstTabClick(payload);

                }
                else {

                    isSuccess = await createMemberFirstTabClick(payload);

                }
            }
            else if (currentTabIndex == 1) {


                var payload2: RequestMembersRegistrySecondTab = {
                    address: requestMembersRegistrySecondTab.address,
                    dateOfBirth: requestMembersRegistrySecondTab.dateOfBirth,
                    age: requestMembersRegistrySecondTab.age,
                    gender: requestMembersRegistrySecondTab.gender,
                    civilStatus: requestMembersRegistrySecondTab.civilStatus,
                    educationalAttainment: requestMembersRegistrySecondTab.educationalAttainment,
                    religion: requestMembersRegistrySecondTab.religion,
                    bodResNo: requestMembersRegistrySecondTab.bodResNo
                }


                isSuccess = await updateMemberSecondTabClick(payload2);


            }


            if (isSuccess) {

                tabs = document.querySelectorAll('.tab');

                var nextIndex = (currentTabIndex + 1) % tabs.length;

                if (nextIndex > 0) {
                    setIsPreviousButtonVisible(true);
                }
                else {
                    setIsPreviousButtonVisible(false);
                }

                if (nextIndex > 1) {
                    setIsNextButtonVisible(false);

                }
                else {
                    setIsNextButtonVisible(true);
                }
                // Open the next tab
                openTab(tabs[nextIndex].id);

            }

        }
        catch (error) {
            console.log('openNextTab error::', error);
        }
        finally {
            document.querySelector('.loader-container')?.classList.remove('loader');
        }
    }

    function openPreviousTab() {


        tabs = document.querySelectorAll('.tab');
        // Calculate index of previous tab
        var previousIndex = (currentTabIndex - 1 + tabs.length) % tabs.length;


        if (previousIndex > 0) {
            setIsPreviousButtonVisible(true);
            setIsNextButtonVisible(true);
        }
        else {
            setIsPreviousButtonVisible(false);
        }


        // Open the previous tab
        openTab(tabs[previousIndex].id);
    }

    function autoGenerateUsernameClick() {

        var firstname: string = requestMembersRegistryFirstTab.firstname || '';
        var lastname: string = requestMembersRegistryFirstTab.lastname || '';

        if (firstname && lastname) {
            const currentDate: Date = new Date();

            // Extract hours, minutes, and seconds
            const hours: number = currentDate.getHours();
            const minutes: number = currentDate.getMinutes();
            const seconds: number = currentDate.getSeconds();
            var username = `${firstname?.charAt(0)}${lastname?.charAt(0)}${hours}${minutes}${seconds}`;

            setRequestMembersRegistryFirstTab({ ...requestMembersRegistryFirstTab, username: username.toLowerCase() });

            setMemberRegistryError((prevState) => ({
                ...prevState,
                username: "",
            }));
        }
        else {
            setMemberRegistryError((prevState) => ({
                ...prevState,
                username: "Firstname and lastname are required to auto generate username.",
            }));
        }
    }

    function autoGeneratePasswordClick() {

        var firstnameInput = requestMembersRegistryFirstTab?.firstname || "";
        var lastnameInput = requestMembersRegistryFirstTab.lastname || "";
        var department = requestMembersRegistryFirstTab.departmentId || "";

        if (firstnameInput && lastnameInput && department) {

            // var department: string = department.substring(0, 3);
            var firstname = firstnameInput.charAt(0);
            var lastname = lastnameInput.charAt(0);
            const currentDate: Date = new Date();
            const day: number = currentDate.getDate();
            const month: number = currentDate.getMonth() + 1;
            const year: number = currentDate.getFullYear() % 100;

            const formattedDay: string = day < 10 ? `0${day}` : `${day}`;
            const formattedMonth: string = month < 10 ? `0${month}` : `${month}`;

            // Format year to have leading zeros if necessary
            const formattedYear: string = year < 10 ? `0${year}` : `${year}`;

            // var generatedPassword = `${department}${firstname}${lastname}${formattedDay}${formattedMonth}${formattedYear}`;
            var generatedPassword = `${firstname}${lastname}${formattedDay}${formattedMonth}${formattedYear}`;

            setRequestMembersRegistryFirstTab({ ...requestMembersRegistryFirstTab, password: generatedPassword.toLowerCase() });
            setConfirmPassword(generatedPassword.toLowerCase());
        }
        else {
            setMemberRegistryError((prevState) => ({
                ...prevState,
                username: "Firstname and lastname are required to auto generate password.",
            }));
        }
    }

    const onClose = () => {
        setIsSuccessModalOpen(false);
        navigate('/Admin/MembersRegistry');
    };

    function cancelButtonClick() {
        navigate('/Admin/MembersRegistry');
    }


    function passwordToggleClick() {
        setIsPasswordVisible(!isPasswordVisible);
    }

    function confirmPasswordToggleClick() {
        setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
    }

    async function getDepartmentsList() {

        try {

            var response = await membersRegistryService.listDepartments();


            response.data.result.forEach((department: ResultDeparment) => {
                var departmentData: SelectData = {
                    value: department.departmentId,
                    label: department.departmentName
                }
                setDepartmentSelectData(oldData => [...oldData, departmentData]);
            })



        }
        catch (err) {
            console.log('err:: ', err);
            throw err;
        }

    }

    useEffect(() => {
        (async () => {
            document.querySelector('.loader-container')?.classList.add('loader');

            getPermission();

            await loadCivilStatusList();

            await getDepartmentsList();

            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);

    return (
        <Layout>
            <SuccessModal message='Member created successfully' isOpen={isSuccessModalOpen} onClose={onClose} ></SuccessModal>
            <div className="title-container">
                <div className="dv-title">

                    <h1>Add Member</h1>

                </div>
                <div className="title-btn-container vertical-flex-bottom">
                    {!isPreviousButtonVisible && <button type="button" id="btnCancel"
                        onClick={cancelButtonClick}
                        className="btn-white-green-2 center-middle">Cancel</button>}

                    {isPreviousButtonVisible && <button type="button" id="btnPrevious"
                        disabled={isReadOnly}
                        // onClick={CancelButtonClick}
                        className="btn-white-green-2 center-middle" onClick={openPreviousTab}>Previous</button>}

                    {isNextButtonVisible && <button type="button" id="btnNext"
                        disabled={isReadOnly}
                        onClick={openNextTab}
                        className="btn-green-2 center-middle">Next</button>}

                    {!isNextButtonVisible && <button type="button" id="btnSave"
                        disabled={isReadOnly}
                        onClick={createMemberThirdTabClick}
                        className="btn-green-2 center-middle">Save</button>}
                    {/* <button type="button" id="prevBtn" onClick={() => openPreviousTab()}>Previous</button>
                <button type="button" id="nextBtn" onClick={() => openNextTab()}>Next</button> */}
                </div>
            </div>
            <br />
            <div className='content-container'>
                <div className='padding-container'>
                    {currentTabIndex !== 0 && (
                        <div>
                            <div>
                                <label className="label-2">Membership Id:</label> <label className="label-3">#{memberTabInfo.membershipId}</label>
                            </div>
                            <div>
                                <label className="label-2">Username:</label>  <label className="label-3">{memberTabInfo.username}</label>
                            </div>
                            <br />
                            <br />
                        </div>
                    )}

                    <div className="wizard-progress">
                        <div className={`step ${currentTabIndex >= 0 ? 'complete' : ''}`}>
                            <div className="node">1</div>
                            <div>Basic Info</div>
                        </div>
                        <div className={`step ${currentTabIndex >= 1 ? 'complete' : ''}`}>
                            <div className="node">2</div>
                            <div>Other Info</div>
                        </div>
                        <div className={`step ${currentTabIndex >= 2 ? 'complete' : ''}`}>
                            <div className="node">3</div>
                            <div>Corporate Info</div>
                        </div>

                    </div>
                    <br />
                    <div id="regForm">
                        <div id="tab1" className="tab active">
                            <div className="title">Basic Info</div>
                            <br></br>
                            <div>
                                <div className='label-1'>
                                    Department:
                                </div>
                            </div>

                            <Select
                                className={memberRegistryError?.department ? "textbox-red-2 " : "textbox-green-2 select"}
                                isDisabled={isReadOnly}
                                options={departmentSelectData}

                                onChange={(opt) =>
                                    setRequestMembersRegistryFirstTab((prevState) => ({
                                        ...prevState,
                                        departmentId: Number(opt?.value)
                                    }))
                                }
                            />

                            <div>
                                <label className='label-error-1'>{memberRegistryError?.department}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    First Name:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={memberRegistryError.firstname ? "textbox-red-2" : "textbox-green-2"} name="firstname" id="txtFirstname" placeholder="Enter First Name"
                                    value={requestMembersRegistryFirstTab?.firstname}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryFirstTab((prevState) => ({
                                            ...prevState,
                                            firstname: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError?.firstname}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Middle Name:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={"textbox-green-2"} name="middlename" id="txtMiddlename" placeholder="Enter Middle Name"
                                    value={requestMembersRegistryFirstTab?.middlename}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryFirstTab((prevState) => ({
                                            ...prevState,
                                            middlename: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'></label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Last Name:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={memberRegistryError.lastname ? "textbox-red-2" : "textbox-green-2"} name="lastname" id="txtLastname" placeholder="Enter Last Name"
                                    value={requestMembersRegistryFirstTab?.lastname}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryFirstTab((prevState) => ({
                                            ...prevState,
                                            lastname: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.lastname}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Tax ID No:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={"textbox-green-2"} name="taxid" id="txtTaxId" placeholder="Enter Tax ID No."
                                    value={requestMembersRegistryFirstTab?.taxIdNo}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryFirstTab((prevState) => ({
                                            ...prevState,
                                            taxIdNo: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'></label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Username:
                                </div>
                            </div>
                            <div className='generate-container'>
                                <input type="text" className={memberRegistryError.username ? "textbox-red-2" : "textbox-green-pass"} name="username" id="txtUsername" placeholder="Enter Username"
                                    value={requestMembersRegistryFirstTab?.username}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryFirstTab((prevState) => ({
                                            ...prevState,
                                            username: event.target.value,
                                        }))
                                    } />
                                <button type="button" id="btnAutoGenerateUsername" style={{ width: '100px' }}
                                    onClick={autoGenerateUsernameClick}
                                    disabled={isReadOnly}
                                    className="btn-white-green-2 center-middle">Auto Generate</button>
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.username}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Password:
                                </div>
                            </div>
                            <div className='generate-container'>
                                <div className="icon-container" >

                                    <input
                                        type={(isPasswordVisible) ? "text" : "password"}
                                        className={memberRegistryError.password ? "textbox-red-2" : "textbox-green-pass"}
                                        name="password" id="txtPassword" placeholder="Enter Password"
                                        value={requestMembersRegistryFirstTab?.password}
                                        disabled={isReadOnly}
                                        onChange={(event) =>
                                            setRequestMembersRegistryFirstTab((prevState) => ({
                                                ...prevState,
                                                password: event.target.value,
                                            }))
                                        } />

                                    {(!isPasswordVisible) ? <span className="toggle-password" onClick={passwordToggleClick}><img src={iconVisible} className="responsive-image" /></span> : ""}
                                    {(isPasswordVisible) ? <span className="toggle-password" onClick={passwordToggleClick}><img src={iconHide} className="responsive-image" /></span> : ""}

                                </div>
                                <button type="button" id="btnAutoGeneratePassword" style={{ width: '100px' }}
                                    onClick={autoGeneratePasswordClick}
                                    disabled={isReadOnly}
                                    className="btn-white-green-2 center-middle">Auto Generate</button>
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.password}</label>
                            </div>


                            <div>
                                <div className='label-1'>
                                    Confirm Password:
                                </div>
                            </div>
                            <div>
                                <div style={{ display: 'inline-block', width: '100%' }}>

                                    <div className="icon-container">
                                        <input type={(isConfirmPasswordVisible) ? "text" : "password"}
                                            className={memberRegistryError.confirmPassword ? "textbox-red-2" : "textbox-green-2"}
                                            name="confirmPassword" id="txtConfirmPassword" placeholder="Enter Confirm Password"
                                            value={confirmPassword}
                                            disabled={isReadOnly}
                                            onChange={(event) =>
                                                setConfirmPassword(event.target.value)

                                            } />
                                        {(!isConfirmPasswordVisible) ? <span className="toggle-password" onClick={confirmPasswordToggleClick}><img src={iconVisible} className="responsive-image" /></span> : ""}
                                        {(isConfirmPasswordVisible) ? <span className="toggle-password" onClick={confirmPasswordToggleClick}><img src={iconHide} className="responsive-image" /></span> : ""}

                                    </div>
                                </div>
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.confirmPassword}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Email:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={memberRegistryError.email ? "textbox-red-2" : "textbox-green-2"} name="email" id="txtEmail" placeholder="eg. koopmember@koop.com"
                                    value={requestMembersRegistryFirstTab?.email}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryFirstTab((prevState) => ({
                                            ...prevState,
                                            email: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.email}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Contact No:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={memberRegistryError.contactNo ? "textbox-red-2" : "textbox-green-2"} name="contactNo" id="txtContactNo" placeholder="Enter Contact No."
                                    value={requestMembersRegistryFirstTab?.contactNo}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryFirstTab((prevState) => ({
                                            ...prevState,
                                            contactNo: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.contactNo}</label>
                            </div>

                        </div>
                        <div id="tab2" className="tab">

                            <div className="title">Other Info</div>

                            <div>
                                <div className='label-1'>
                                    Address:
                                </div>
                            </div>
                            <div>
                                <textarea className={memberRegistryError.address ? "textbox-red-2" : "textbox-green-2"} name="address" id="txtAddress" placeholder="Enter Address"
                                    value={requestMembersRegistrySecondTab?.address}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistrySecondTab((prevState) => ({
                                            ...prevState,
                                            address: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.address}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Date of Birth:
                                </div>
                            </div>
                            <div>
                                <DatePicker className={memberRegistryError.dateOfBirth ? "textbox-red-2" : "textbox-green-2"} name="dateOfBirth" id="txtDateOfBirth"
                                    selected={requestMembersRegistrySecondTab?.dateOfBirth}
                                    disabled={isReadOnly}
                                    onChange={(date: Date | null) => {
                                        setRequestMembersRegistrySecondTab((prevState) => ({
                                            ...prevState,
                                            dateOfBirth: date,
                                            age: date
                                                ? Math.floor(
                                                    (new Date().getTime() - date.getTime()) / (1000 * 60 * 60 * 24 * 365.25)
                                                ).toString()
                                                : '0',
                                        }));
                                    }} />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.dateOfBirth}</label>
                            </div>
                            <div>
                                <div className='label-1'>
                                    Age:
                                </div>
                            </div>
                            <div>
                                <input type="number" className={memberRegistryError.age ? "textbox-red-2" : "textbox-green-2"} name="age" id="txtAge" placeholder="Enter Age"
                                    value={requestMembersRegistrySecondTab?.age}
                                    disabled />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.age}</label>
                            </div>
                            <div>
                                <div className='label-1'>
                                    Gender:
                                </div>
                            </div>
                            <div>
                                <select className={memberRegistryError.gender ? "textbox-red-2" : "textbox-green-2"}
                                    value={requestMembersRegistrySecondTab?.gender}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistrySecondTab((prevState) => ({
                                            ...prevState,
                                            gender: event.target.value,
                                        }))
                                    }>
                                    <option value=""></option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.gender}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Civil Status:
                                </div>
                            </div>
                            <div>
                                <select className={memberRegistryError.civilStatus ? "textbox-red-2" : "textbox-green-2"}
                                    value={requestMembersRegistrySecondTab?.civilStatus}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistrySecondTab((prevState) => ({
                                            ...prevState,
                                            civilStatus: Number(event.target.value),
                                        }))
                                    }>

                                    <option value=""></option>
                                    {
                                        civilStatusList.map((item) => (
                                            <option key={item.value} value={item.value}>{item.displayName}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.civilStatus}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Educational Attainment:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={memberRegistryError.educationalAttainment ? "textbox-red-2" : "textbox-green-2"} name="educationalAttainment" id="txtEducationalAttainment" placeholder="Educational Attainment"
                                    value={requestMembersRegistrySecondTab?.educationalAttainment}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistrySecondTab((prevState) => ({
                                            ...prevState,
                                            educationalAttainment: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.educationalAttainment}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Religion:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={memberRegistryError.religion ? "textbox-red-2" : "textbox-green-2"} name="religion" id="txtReligion" placeholder="Enter Religion"
                                    value={requestMembersRegistrySecondTab?.religion}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistrySecondTab((prevState) => ({
                                            ...prevState,
                                            religion: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.religion}</label>
                            </div>

                              <div>
                                <div className='label-1'>
                                    BOD Res. No.:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={memberRegistryError.bodResNo ? "textbox-red-2" : "textbox-green-2"} name="bodResNo" id="txtBodResNo" placeholder="Enter BOD Res No"
                                    value={requestMembersRegistrySecondTab?.bodResNo}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistrySecondTab((prevState) => ({
                                            ...prevState,
                                            bodResNo: event.target.value,
                                        }))
                                    } />
                            </div>

                        </div>
                        <div id="tab3" className="tab">
                            <div className="title">Corporate Info</div><br />
                            <div>
                                <div className='label-1'>
                                    Occupation:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={memberRegistryError.occupation ? "textbox-red-2" : "textbox-green-2"} name="occupation" id="txtOccupation" placeholder="Enter Occupation"
                                    value={requestMembersRegistryThirdTab?.occupation}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryThirdTab((prevState) => ({
                                            ...prevState,
                                            occupation: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.occupation}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Annual Income:
                                </div>
                            </div>
                            <div>
                                <input type="number" className={memberRegistryError.annualIncome ? "textbox-red-2" : "textbox-green-2"} name="annualIncome" id="txtAnnualIncome" placeholder="Enter Annual Income"
                                    value={requestMembersRegistryThirdTab?.annualIncome}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryThirdTab((prevState) => ({
                                            ...prevState,
                                            annualIncome: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.annualIncome}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Number of Dependents:
                                </div>
                            </div>
                            <div>
                                <input type="number" className={memberRegistryError.numberOfDependents ? "textbox-red-2" : "textbox-green-2"} name="numberOfDependents" id="txtNumberOfDependents" placeholder="Enter Number of Dependents"
                                    value={requestMembersRegistryThirdTab?.numberOfDependents}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryThirdTab((prevState) => ({
                                            ...prevState,
                                            numberOfDependents: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.numberOfDependents}</label>
                            </div>


                            <div>
                                <div className='label-1'>
                                    Date Accepted:
                                </div>
                            </div>
                            <div>
                                <DatePicker className={memberRegistryError.dateAccepted ? "textbox-red-2" : "textbox-green-2"} name="dateAccepted" id="txtDateAccepted"
                                    selected={requestMembersRegistryThirdTab?.dateAccepted || null}
                                    disabled={isReadOnly}
                                    onChange={(date: Date | null) => {
                                        setRequestMembersRegistryThirdTab((prevState) => ({
                                            ...prevState,
                                            dateAccepted: date,
                                        }));
                                    }} />

                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.dateAccepted}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Date of Separation:
                                </div>
                            </div>
                            <div>
                                <DatePicker className={"textbox-green-2"} name="dateOfSeparation" id="txtDateOfSeparation"
                                    selected={requestMembersRegistryThirdTab?.dateOfSeparation || null}
                                    disabled={isReadOnly}
                                    onChange={(date: Date | null) => {
                                        setRequestMembersRegistryThirdTab((prevState) => ({
                                            ...prevState,
                                            dateOfSeparation: date,
                                        }));
                                    }} />

                            </div>
                            <div>
                                <label className='label-error-1'></label>
                            </div>


                            <div>
                                <div className='label-1'>
                                    Membership Type:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={memberRegistryError.membershipType ? "textbox-red-2" : "textbox-green-2"} name="membershipType" id="txtMembershipType" placeholder="Enter Membership Type"
                                    value={requestMembersRegistryThirdTab?.membershipType}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryThirdTab((prevState) => ({
                                            ...prevState,
                                            membershipType: event.target.value,
                                        }))
                                    } 
                                />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.membershipType}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Amount Subscribed:
                                </div>
                            </div>
                            <div>
                                <input type="number" className={memberRegistryError.amountSubscribe ? "textbox-red-2" : "textbox-green-2"} name="amountSubscribed" id="txtAmountSubscribed" placeholder="Enter Amount Subscribed"
                                    value={requestMembersRegistryThirdTab?.amountSubscribe}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryThirdTab((prevState) => ({
                                            ...prevState,
                                            amountSubscribe: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.amountSubscribe}</label>
                            </div>

                            <div>
                                <div className='label-1'>
                                    Initial Paid Up Amount:
                                </div>
                            </div>
                            <div>
                                <input type="number" className={"textbox-green-2"} name="dependents" id="txtOccupation" placeholder="Enter Initial Paid Up Amount"
                                    value={requestMembersRegistryThirdTab?.initialPaidAmount}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryThirdTab((prevState) => ({
                                            ...prevState,
                                            initialPaidAmount: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'></label>
                            </div>

                            
                            <div>
                                <div className='label-1'>
                                    BOD Res. No. Termination:
                                </div>
                            </div>
                            <div>
                                <input type="text" className={memberRegistryError.bodResNoTermination ? "textbox-red-2" : "textbox-green-2"} name="bodResNoTermination" id="txtBodResNoTermination" placeholder="Enter BOD Res No"
                                    value={requestMembersRegistryThirdTab?.bodResNoTermination}
                                    disabled={isReadOnly}
                                    onChange={(event) =>
                                        setRequestMembersRegistryThirdTab((prevState) => ({
                                            ...prevState,
                                            bodResNoTermination: event.target.value,
                                        }))
                                    } />
                            </div>
                            <div>
                                <label className='label-error-1'>{memberRegistryError.bodResNoTermination}</label>
                            </div>

                        </div>

                        <div className="title-btn-container btn-mobile">

                            {!isPreviousButtonVisible && <button type="button" id="btnCancel"
                                onClick={cancelButtonClick}
                                className="btn-white-green-2 center-middle">Cancel</button>}

                            {isPreviousButtonVisible && <button type="button" id="btnPrevious"
                                disabled={isReadOnly}
                                // onClick={CancelButtonClick}
                                className="btn-white-green-2 center-middle" onClick={openPreviousTab}>Previous</button>}

                            {isNextButtonVisible && <button type="button" id="btnNext"
                                disabled={isReadOnly}
                                onClick={openNextTab}
                                className="btn-green-2 center-middle">Next</button>}

                            {!isNextButtonVisible && <button type="button" id="btnSave"
                                disabled={isReadOnly}
                                onClick={createMemberThirdTabClick}
                                className="btn-green-2 center-middle">Save</button>}
                            {/* <button type="button" id="prevBtn" onClick={() => openPreviousTab()}>Previous</button>
<button type="button" id="nextBtn" onClick={() => openNextTab()}>Next</button> */}
                        </div>

                        <div style={{ overflow: "auto" }}>
                            <div style={{ float: "right" }}>
                                {/* <button type="button" id="prevBtn" onClick={() => nextPrev(-1)}>Previous</button>
                        <button type="button" id="nextBtn" onClick={() => nextPrev(1)}>Next</button> */}
                                {/* <button type="button" id="prevBtn" onClick={() => openPreviousTab()}>Previous</button>
                        <button type="button" id="nextBtn" onClick={() => openNextTab()}>Next</button> */}
                            </div>
                        </div>


                    </div>
                </div>

            </div>





        </Layout >

    );
}



export default CreateMember;